import {SubscribedUser} from '@paperlessio/sdk/api/models';
import {SelectedBlocksChangedItem} from '@management/base/services/channel/channel.type';

export class BlockSelection {
  subscription_uuid: string;
  subscribedUser: SubscribedUser;
  name: string;
  email: string;
  selected_block_ids: number[];
  selected_page_ids: number[];
  colorIndex: number;

  constructor(subscribedUser: SubscribedUser,
              selectedBlocksChangedItem: SelectedBlocksChangedItem,
              selected_page_ids: number[]) {
    this.subscription_uuid = subscribedUser.subscription_uuid;
    this.subscribedUser = subscribedUser;
    this.name = subscribedUser.name;
    this.email = subscribedUser.email;
    this.selected_block_ids = selectedBlocksChangedItem.selected_block_ids || [];
    this.selected_page_ids = selected_page_ids;
    this.colorIndex = subscribedUser.colorIndex;
  }

  isSelected = (blockId: number) => blockId !== undefined && this.selected_block_ids.includes(blockId);
}
